import { filter, wrap } from "lodash";
import React, { useState, useEffect } from "react";
import { styled } from "@mui/material/styles";
import DataTable from "react-data-table-component";
// material
import {
  Card,
  Stack,
  Container,
  Typography,
  Button,
  Tooltip,
  IconButton,
  Grid,
  TextField,
  Box,
  RadioGroup,
  FormControlLabel,
  Radio,
  FormLabel,
  CircularProgress,
  FormGroup,
  Switch,
  Avatar,
  Tabs,
  Tab
} from "@mui/material";
import Label from "../components/Label";
import {
  EditSharp,
  LogoutSharp,
  CurrencyRupeeSharp,
  RemoveRedEye,
  EmojiEvents,
  VerifiedUser,
  NoteAdd,
  Description,
  DownloadOutlined,
  ListAlt,
  Close,
  People,
  CheckCircle,
  Block,
  WarningAmber
} from "@mui/icons-material";
// components
import Page from "../components/Page";
import { MemberForm } from "../components/Form/Member";
import {
  GetPrimeMemberById,
  UpdateMemberStatus,
  downloadMemberInvocie,
  generateMemberInvoice,
  getMemberConnectedandBlockList,
  updateConnectionRequestMailStatus,
  getPrimeMemberDeactiveReason,
  getPromoCodeApi,
  orangeTickApproveRejectApi,
  userLogout
} from "src/api/commonapi";
import { notification } from "src/utils/messages";
import Select from "react-select";
import Modal from "@mui/material/Modal";
import { CSVLink } from "react-csv";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { enGB } from "date-fns/locale";
import moment from "moment";
import { fetchallcitylist, fetchallstatelist, GetAllPrimeMember } from "src/utils/common";
import { Routes } from "src/constant/api_url";
import { gender, IsNotValue } from "src/constant/variable";
import { FormControl, ModalBody } from "react-bootstrap";
import CustomLoader from "src/components/CustomLoader";

export default function Member() {
  let loginUser = JSON.parse(localStorage.getItem("userData"));
  const [step, setStep] = useState(1);
  const [citylist, setcitylist] = useState([]);
  const [statelist, setstatelist] = useState([]);
  const [memberlist, setmemberlist] = useState([]);
  const [editMember, setEditMemberData] = useState(null);
  const [statusresp, setstatusresp] = useState(0);
  const [newMemeberList, setNewMemberList] = useState([]);
  const [activeMembercnt, setactiveMembercnt] = useState(0);
  const [deactiveMembercnt, setdeactiveMembercnt] = useState(0);
  const [getMemberConnectedListData, setMemberConnectedList] = useState([]);
  const [getMemberBlockListData, setMemberBlockList] = useState([]);
  const [connectedBlockModalOpen, setConnectedBlockModalOpen] = useState(false);
  const [connectedBlockTab, setConnectedBlockTab] = useState(0);
  const [connectionMailMemberId, setConnectionMailMemberId] = useState(null);
  const [conMailStatus, setConMailStatus] = useState(1);
  const [orangeTickConfirmationModalOpen, setOrangeTickConfirmationModalOpen] = useState(false);
  const [memberDeActiveModal, setmemberDeActiveModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [memberdeactiveReasons, setMemberdeactiveReasons] = useState({
    m_id: "",
    status: "",
    reasons: "",
    deactivation_date: null
  });
  const [downloadingId, setDownloadingId] = useState(null);
  const [generateInvocieModal, setGenerateInvocieModal] = useState(false);
  const [invoiceData, setInvocieData] = useState({
    pr_gst_check: "",
    pr_gstno: "",
    m_id: ""
  });
  const [isLoading_invoiceMember, setIsLoading_invoiceMember] = useState(false);
  const [seeMemberDeActiveModal, setSeeMemberDeActiveModal] = useState(false);
  const [statusChangeLoading, setStatusChangeLoading] = useState(false);
  const [orangeTickStatus, setOrangeTickStatus] = useState("");
  const [promocodeList, setPromoCodeList] = useState([]);

  const [deActivateReasonData, setDeActivateReasonData] = useState({
    memberName: "",
    deActivationDate: "",
    deActivationReason: ""
  });

  const [filtereddata, setFilteredData] = useState({
    filtermember: "",
    startDate: null,
    endDate: null,
    search_date_type: 0,
    activeMemberSearchType: 0,
    activeMemberInvoice: -1,
    gender: -1,
    activeInvoiceType: -1,
    memberSource: -1,
    activeMemberTickType: [-1],
    filterCity: 0,
    filterState: 0,
    whatsappgroup: -1,
    promocode: 0
  });

  const handleGetPromoCodeData = async () => {
    const resp = await getPromoCodeApi();
    if (resp.status == 1) {
      setPromoCodeList(resp.data);
    }
  };

  const filterData = (returnFilterData = false) => {
    let nmember = [];
    nmember =
      memberlist &&
      memberlist?.filter((member) => {
        if (
          (filtereddata?.whatsappgroup == 1
            ? !IsNotValue.includes(member?.pr_ex1)
            : filtereddata?.whatsappgroup == 2
              ? IsNotValue.includes(member?.pr_ex1)
              : !IsNotValue.includes(member?.pr_ex1) || IsNotValue.includes(member?.pr_ex1)) &&
          (filtereddata?.activeMemberSearchType == 0
            ? member.status == 0 || member.status == 1
            : filtereddata?.activeMemberSearchType == 1
              ? member.status == 1
              : member.status == 0) &&
          (filtereddata?.memberSource == -1
            ? member.member_source == 0 || member.member_source == 1
            : filtereddata?.memberSource == 1
              ? member.member_source == 1
              : filtereddata?.memberSource == 2
                ? member?.member_source == 0 && member?.pr_payment_mode == 1
                : member.member_source == 0) &&
          (filtereddata?.activeMemberInvoice == -1
            ? member.pr_i_generate == 0 || member.pr_i_generate == 1
            : filtereddata?.activeMemberInvoice == 1
              ? member.pr_i_generate == 1
              : member.pr_i_generate == 0) &&
          (filtereddata?.activeInvoiceType == -1
            ? member.pr_gst_check == 0 || member.pr_gst_check == 1
            : filtereddata?.activeInvoiceType == 1
              ? member.pr_gst_check == 1
              : member.pr_gst_check == 0) &&
          (filtereddata?.activeMemberTickType.length == 0 ||
            filtereddata?.activeMemberTickType.includes(-1) ||
            filtereddata?.activeMemberTickType.includes(member.m_verify_status)) &&
          (filtereddata?.gender === -1 || member.gender === filtereddata?.gender) &&
          (member.m_name?.toLowerCase().includes(filtereddata?.filtermember?.toLowerCase()) ||
            (member.m_email_id || "")
              ?.toLowerCase()
              .includes(filtereddata?.filtermember?.toLowerCase()) ||
            member?.business_name
              ?.toLowerCase()
              .includes(filtereddata?.filtermember?.toLowerCase()) ||
            member.business_category
              ?.toLowerCase()
              .includes(filtereddata?.filtermember?.toLowerCase()) ||
            member.mobile_no?.toLowerCase().includes(filtereddata?.filtermember?.toLowerCase()) ||
            (member.village !== null &&
              member.village?.toLowerCase().includes(filtereddata?.filtermember?.toLowerCase()))) &&
          (filtereddata?.filterCity === 0 || member.city_id === filtereddata?.filterCity) &&
          (filtereddata?.promocode === 0 || member.p_code_id === filtereddata?.promocode) &&
          (filtereddata?.filterState === 0 || member.state_id === filtereddata?.filterState)
        ) {
          return member;
        }
      });

    if (returnFilterData == true) {
      return nmember;
    } else {
      setNewMemberList(nmember);
      setactivedeactive(nmember);
    }
  };
  const getallcitylist = async () => {
    setcitylist(await fetchallcitylist());
  };

  const getallstatelist = async () => {
    setstatelist(await fetchallstatelist());
  };

  const FilterDateWise = async () => {
    let nmember = [];

    if (filtereddata?.startDate != null && filtereddata?.endDate != null) {
      const parseDate = (str) => {
        if (!str || typeof str !== "string") return null;
        const [dd, mm, yyyy] = str.split("-");
        return new Date(`${yyyy}-${mm}-${dd}`); // Convert to YYYY-MM-DD
      };

      const startDate = parseDate(filtereddata?.startDate);
      const endDate = parseDate(filtereddata?.endDate);

      // Normalize time
      startDate.setHours(0, 0, 0, 0);
      endDate.setHours(0, 0, 0, 0);

      nmember =
        memberlist &&
        memberlist.filter((member) => {
          if (member.joining_date != "") {
            const statusMatch =
              filtereddata?.activeMemberSearchType == 0
                ? member.status == 0 || member.status == 1
                : filtereddata?.activeMemberSearchType == 1
                  ? member.status == 1
                  : member.status == 0;

            const sourceMatch =
              filtereddata?.memberSource == -1
                ? member.member_source == 0 || member.member_source == 1
                : filtereddata?.memberSource == 1
                  ? member.member_source == 1
                  : filtereddata?.memberSource == 2
                    ? member?.member_source == 0 && member?.pr_payment_mode == 1
                    : member.member_source == 0;

            const whatsappGroupMatch =
              filtereddata?.whatsappgroup == 1
                ? !IsNotValue.includes(member.pr_ex1)
                : filtereddata?.whatsappgroup == 2
                  ? IsNotValue.includes(member.pr_ex1)
                  : !IsNotValue.includes(member.pr_ex1) || IsNotValue.includes(member.pr_ex1);

            const invoiceMatch =
              filtereddata?.activeMemberInvoice == -1
                ? member.pr_i_generate == 0 || member.pr_i_generate == 1
                : filtereddata?.activeMemberInvoice == 1
                  ? member.pr_i_generate == 1
                  : member.pr_i_generate == 0;

            const invoiceTypeMatch =
              filtereddata?.activeInvoiceType == -1
                ? member.pr_gst_check == 0 || member.pr_gst_check == 1
                : filtereddata?.activeInvoiceType == 1
                  ? member.pr_gst_check == 1
                  : member.pr_gst_check == 0;

            const tickTypeMatch =
              filtereddata?.activeMemberTickType.length == 0 ||
              filtereddata?.activeMemberTickType.includes(-1) ||
              filtereddata?.activeMemberTickType.includes(member.m_verify_status);

            const keywordMatch =
              member.m_name?.toLowerCase().includes(filtereddata?.filtermember?.toLowerCase()) ||
              member?.business_name
                ?.toLowerCase()
                .includes(filtereddata?.filtermember?.toLowerCase()) ||
              member.mobile_no?.toLowerCase().includes(filtereddata?.filtermember?.toLowerCase());

            const genderMatch =
              filtereddata?.gender === -1 || member.gender === filtereddata?.gender;
            const cityMatch =
              filtereddata?.filterCity === 0 || member.city_id === filtereddata?.filterCity;
            const promocodeMatch =
              filtereddata?.promocode === 0 || member.p_code_id === filtereddata?.promocode;
            const stateMatch =
              filtereddata?.filterState === 0 || member.state_id === filtereddata?.filterState;

            const rawDateStr =
              filtereddata?.search_date_type == 0
                ? parseDate(member.joining_date)
                : filtereddata?.search_date_type == 1
                  ? parseDate(member.due_date)
                  : parseDate(member.deactivation_date);

            let dateMatch = true;
            if (startDate && endDate && rawDateStr) {
              rawDateStr.setHours(0, 0, 0, 0);
              dateMatch = rawDateStr >= startDate && rawDateStr <= endDate;
            }
            return (
              genderMatch &&
              statusMatch &&
              sourceMatch &&
              promocodeMatch &&
              invoiceMatch &&
              invoiceTypeMatch &&
              tickTypeMatch &&
              keywordMatch &&
              cityMatch &&
              stateMatch &&
              whatsappGroupMatch &&
              dateMatch
            );
          }
        });

      setNewMemberList(nmember);
      setactivedeactive(nmember);
    } else {
      // Optional: Show error if dates are missing
      // notification({ type: "error", message: "Please select Start Date and End Date" });
    }
  };

  const setactivedeactive = (newMemeberList) => {
    let actcnt = 0;
    let deactcnt = 0;

    newMemeberList?.map((e, key) => {
      if (e.status == 0) {
        deactcnt = deactcnt + 1;
      } else if (e.status == 1) {
        actcnt = actcnt + 1;
      }
    });
    setactiveMembercnt(actcnt);
    setdeactiveMembercnt(deactcnt);
  };

  useEffect(async () => {
    setIsLoading(true);
    setmemberlist(await GetAllPrimeMember());
    setIsLoading(false);
  }, [step, statusresp]);

  useEffect(async () => {
    if (
      filtereddata?.filtermember != undefined ||
      filtereddata?.startDate != null ||
      filtereddata?.endDate != null
    ) {
      await filterData();
      await FilterDateWise();
    }
  }, [filtereddata, memberlist]);

  const changestatus = async (m_id, status, reason = "", date = null) => {
    setStatusChangeLoading(true);
    let fdata = new FormData();
    fdata.append("m_id", m_id);
    fdata.append("status", status);
    fdata.append("reason", reason);
    fdata.append("deactivation_date", date);

    if ((status == 0 && reason != "" && date != null) || (status == 1 && reason == "")) {
      setIsLoading(true);
      const resp = await UpdateMemberStatus(fdata);
      setIsLoading(false);
      setStatusChangeLoading(false);
      let notify = notification({
        type: resp.status == 0 ? "error" : "success",
        message: resp.message
      });
      notify();
      if (resp.status == 1) {
        setstatusresp(statusresp + 1);
        setMemberdeactiveReasons({
          m_id: "",
          status: "",
          reasons: ""
        });
        setmemberDeActiveModal(false);
      }
    } else {
      setStatusChangeLoading(false);
      let notify = notification({
        type: "error",
        message: "Please Check Reason Or Date And Try Again"
      });
      notify();
    }
  };

  const downloadInvocieData = async (member_id) => {
    try {
      setDownloadingId(member_id);
      const resp = await downloadMemberInvocie(member_id);

      if (resp.status == 1 && resp.data.filename) {
        const fileUrl = `${Routes.API_HOSTNAME}invoice-pdf/${resp.data.filename}`;

        // Fetch the file as a blob
        const response = await fetch(fileUrl, { method: "GET" });
        const blob = await response.blob();
        const blobUrl = window.URL.createObjectURL(blob);

        // Create an invisible <a> element to trigger download
        const link = document.createElement("a");
        link.href = blobUrl;
        link.setAttribute("download", resp.data.filename); // Force download
        document.body.appendChild(link);
        link.click();

        // Cleanup
        document.body.removeChild(link);
        window.URL.revokeObjectURL(blobUrl);
      } else {
        let notify = notification({
          type: resp.status == 0 ? "error" : "success",
          message: "Invoice Not Download"
        });
        notify();
      }
    } catch (error) {
      console.error("Download error:", error);
    } finally {
      setDownloadingId(null); // Re-enable the button
    }
  };

  const handlememberinvoiceform = async (e) => {
    setInvocieData({ ...invoiceData, [e.target.name]: e.target.value });
  };

  const submitMemberInvoiceForm = async () => {
    const gstRegex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;

    // Required GST validation if GST type is selected
    if (invoiceData.pr_gst_check == "1") {
      if (!invoiceData.pr_gstno || invoiceData.pr_gstno.trim() === "") {
        notification({
          type: "error",
          message: "Please Enter GST No."
        })();
        return;
      }

      if (!gstRegex.test(invoiceData.pr_gstno.trim())) {
        notification({
          type: "error",
          message: "Invalid GST No. format."
        })();
        return;
      }
    }

    if (!invoiceData.m_id) {
      notification({
        type: "error",
        message: "Member ID is missing."
      })();
      return;
    }

    if (invoiceData.pr_gst_check != undefined && invoiceData.pr_gst_check.trim() != "") {
      let fndata = new FormData();
      fndata.append("pr_gst_check", invoiceData.pr_gst_check);
      fndata.append("pr_gstno", invoiceData.pr_gstno);
      fndata.append("m_id", invoiceData.m_id);
      setIsLoading_invoiceMember(true);

      let resp = await generateMemberInvoice(fndata);

      let notify = notification({
        type: resp.status == 0 ? "error" : "success",
        message: resp.message
      });
      notify();

      if (resp.status == 1 && resp.filename) {
        const fileUrl = `${Routes.API_HOSTNAME}invoice-pdf/${resp.filename}`;

        // Fetch the file as a blob
        const response = await fetch(fileUrl, { method: "GET" });
        const blob = await response.blob();
        const blobUrl = window.URL.createObjectURL(blob);

        // Create an invisible <a> element to trigger download
        const link = document.createElement("a");
        link.href = blobUrl;
        link.setAttribute("download", resp.filename); // Force download
        document.body.appendChild(link);
        link.click();

        // Cleanup
        document.body.removeChild(link);
        window.URL.revokeObjectURL(blobUrl);

        setstatusresp(statusresp + 1);

        setIsLoading_invoiceMember(false);
        setGenerateInvocieModal(false);
        cancelMemberInvoiceModal();
        setInvocieData({
          pr_gst_check: "",
          pr_gstno: "",
          m_id: ""
        });
      }
      setIsLoading_invoiceMember(false);
    } else {
      let notify = notification({
        type: "error",
        message: `Please Select GST Type`
      });
      notify();
    }
  };

  const ulogout = async (m_id) => {
    const resp = await userLogout(m_id);

    let notify = notification({
      type: resp.status == 0 ? "error" : "success",
      message: resp.message
    });
    notify();

    if (resp.status == 1) {
      setstatusresp(statusresp + 1);
    }
  };

  const getmember = async (id) => {
    const response = await GetPrimeMemberById(id);
    setEditMemberData({
      ...response.data,
      c_id: response?.data.country_id,
      occupation_type: response?.data?.pr_occupation_type
    });
    setStep(3);
  };

  const genderLabel = ["Not Selected", "Male", "Female"];

  const formattedCSVData = newMemeberList?.map((row, index) => ({
    m_id: index + 1,
    m_name: row.m_name,
    gender: genderLabel[Number(row.gender)],
    mobile_no: row.mobile_no,
    m_email_id: row.m_email_id,
    joining_date: row.joining_date,
    due_date: row.due_date,
    business_name: row.business_name,
    pr_welcome_kit_address: row?.pr_welcome_kit_address,
    business_category: row.business_category,
    Current_Status: row.Current_Status,
    deactivation_date: row.deactivation_date,
    member_deactive_reason: row.member_deactive_reason,
    state_name: row.state_name,
    city_name: row.city_name
  }));

  const expo_columns = [
    { label: "No", key: "m_id" },
    { label: "Member Name", key: "m_name" },
    { label: "Gender", key: "gender" },

    { label: "Contact No", key: "mobile_no" },
    { label: "Email", key: "m_email_id" },
    {
      label: "Join Date",
      key: "joining_date"
    },
    {
      label: "Expire Date",
      key: "due_date"
    },
    { label: "Business Name", key: "business_name" },
    { label: "Welcome Kit Address", key: "pr_welcome_kit_address" },
    { label: "Business Category", key: "business_category" },
    { label: "Status", key: "Current_Status" },
    { label: "Deactivation Date", key: "deactivation_date" },
    { label: "Deactivation Reason", key: "member_deactive_reason" },
    { label: "State", key: "state_name" },
    { label: "City", key: "city_name" }
  ];

  const expo_columns_Additional = [
    { label: "No", key: "m_id" },
    { label: "Member Name", key: "m_name" },
    { label: "Contact No", key: "mobile_no" },
    { label: "Email", key: "m_email_id" },
    { label: "Business Name", key: "business_name" },
    { label: "Welcome Kit Address", key: "pr_welcome_kit_address" },
    { label: "Business Category", key: "business_category" },
    { label: "Business Since", key: "business_since" },
    { label: "Business Description", key: "business_desc" },
    { label: "Business Address", key: "b_address" },
    { label: "Status", key: "Current_Status" },
    { label: "DOB", key: "dob" },
    { label: "Blood Group", key: "blood_group" },
    { label: "Member Position", key: "member_new_position" },
    { label: "Website URL", key: "website_url" },
    { label: "Facebook URL", key: "fb" },
    { label: "Instagram URL", key: "instagram" },
    { label: "LinkedIn URL", key: "linkedin" },
    { label: "Twitter URL", key: "twitter" },
    { label: "YouTube URL", key: "youtube" },
    {
      label: "Join Date",
      key: "joining_date"
    },
    {
      label: "Expire Date",
      key: "due_date"
    },
    { label: "Reference By", key: "member_referal_by" },
    { label: "Deactivation Date", key: "deactivation_date" },
    { label: "Deactivation Reason", key: "member_deactive_reason" },
    { label: "Whatsapp Group", key: "pr_ex1" },
    { label: "Extra Field", key: "pr_ex2" }
  ];

  const conditionalRowStyles = [
    {
      when: (row) => row.member_source === 1, // condition
      style: {
        backgroundColor: "#098cea38" // light yellow background
        // color: "#000000" // optional text color
      }
    }
  ];

  const handleGetMemberConnectedandBlockList = async (m_id) => {
    try {
      const response = await getMemberConnectedandBlockList({ m_id });
      const connected = response?.data?.connectedMember ?? response?.connectedMember ?? [];
      const blocked = response?.data?.blockedMember ?? response?.blockedMember ?? [];
      setMemberConnectedList(connected);
      setMemberBlockList(blocked);
      setConnectedBlockTab(0);
      setConnectionMailMemberId(m_id);
      setConMailStatus(response?.data?.con_mail_status ?? 1);
      setConnectedBlockModalOpen(true);
    } catch (error) {
      console.log("error", error);
    }
  };

  const handleToggleConnectionMail = async () => {
    const newStatus = conMailStatus === 1 ? 0 : 1;
    try {
      const resp = await updateConnectionRequestMailStatus({
        m_id: connectionMailMemberId,
        con_mail_status: newStatus
      });
      if (resp?.status === 1) {
        setConMailStatus(newStatus);
        let notify = notification({
          type: "success",
          message: resp.message || "Connection mail status updated"
        });
        notify();
      } else {
        let notify = notification({
          type: "error",
          message: resp?.message || "Failed to update"
        });
        notify();
      }
    } catch (error) {
      let notify = notification({
        type: "error",
        message: "Something went wrong"
      });
      notify();
    }
  };

  const handleOrangeTickApproveReject = async () => {
    setIsLoading(true);

    const resp = await orangeTickApproveRejectApi({
      m_id: editMember?.m_id,
      m_verify_status: orangeTickStatus
    });

    let notify = notification({
      type: resp.status == 0 ? "error" : "success",
      message: resp.message
    });
    notify();
    setOrangeTickConfirmationModalOpen(false);
    setmemberlist(await GetAllPrimeMember());
    setIsLoading(false);
  };

  const OrangeSwitch = styled(Switch)(({ theme }) => ({
    "& .MuiSwitch-switchBase.Mui-checked": {
      color: "#ff9342"
    },
    "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
      backgroundColor: "orange"
    }
  }));

  const columns = [
    {
      name: "Id",
      selector: (row) => row?.m_id,
      sortable: true,
      wrap: true,
      width: "70px"
    },
    {
      name: "Member Type",
      selector: (row) =>
        row?.member_source == 0 && row?.pr_payment_mode == 0
          ? "Prime"
          : row?.member_source == 0 && row?.pr_payment_mode == 1
            ? "Offline"
            : row?.member_source == 1
              ? "Privilege to Prime"
              : "",
      sortable: true,
      wrap: true,
      width: "150px"
    },
    {
      name: "Member Name",
      wrap: true,
      width: "150px",
      selector: (row) => (
        <>
          <a
            style={{
              cursor: "pointer",
              overflow: "visible",
              whiteSpace: "pre-line"
            }}
          >
            {row.m_name}
          </a>
        </>
      ),
      sortable: true
    },
    {
      name: "Member Email",
      wrap: true,
      width: "250px",
      selector: (row) => (
        <span
          style={{
            color: row.email_verify === 1 ? "green" : "red",
            fontWeight: 600
          }}
        >
          {!IsNotValue.includes(row.m_email_id) ? row.m_email_id : ""}
        </span>
      ),
      sortable: true
    },
    {
      name: "Business Name",
      selector: (row) => row.business_name,
      sortable: true,
      wrap: true,
      width: "150px"
    },
    {
      name: "Business Category",
      selector: (row) => row.business_category,
      sortable: true,
      wrap: true,
      width: "120px"
    },
    {
      name: "City Name",
      selector: (row) => row.city_name,
      sortable: true,
      wrap: true,
      width: "150px"
    },
    {
      name: "State Name",
      selector: (row) => row.state_name,
      sortable: true,
      wrap: true,
      width: "150px"
    },
    {
      name: "Contact No",
      wrap: true,
      width: "120px",
      selector: (row) => row.mobile_no
    },
    {
      name: "Join Date",
      wrap: true,
      selector: (row) => row.joining_date
    },
    {
      name: "Gender",
      selector: (row) => genderLabel[Number(row?.gender)],
      sortable: true,
      wrap: true,
      width: "150px"
    },
    {
      name: "Deactivate Date",
      wrap: true,
      selector: (row) => row.deactivation_date
    },
    {
      name: "Status",
      wrap: true,
      width: "150px",
      selector: (row) => (
        <>
          {row.status == 1 ? (
            <>
              <div style={{ margin: "10px 0" }}>
                <Label
                  variant="ghost"
                  color="success"
                  style={{
                    marginBottom: "10px",
                    display: "flex",
                    fontSize: "16px"
                  }}
                >
                  Active
                </Label>

                <Button
                  variant="contained"
                  onClick={() => {
                    setMemberdeactiveReasons({
                      m_id: row.m_id,
                      status: 0,
                      reason: ""
                    });

                    setmemberDeActiveModal(true);
                  }}
                  style={{ background: "#ff4842" }}
                >
                  Deactive
                </Button>
              </div>
            </>
          ) : (
            <>
              <div style={{ margin: "10px 0" }}>
                <Label
                  variant="ghost"
                  color="error"
                  style={{
                    marginBottom: "10px",
                    display: "flex",
                    fontSize: "14px"
                  }}
                >
                  Deactive
                </Label>

                <Button
                  variant="contained"
                  onClick={() => {
                    changestatus(row.m_id, 1);
                  }}
                  disabled={isLoading}
                  startIcon={isLoading && <CircularProgress size={20} color="inherit" />}
                >
                  Active
                </Button>
              </div>
            </>
          )}
        </>
      )
    },
    {
      name: "Action",
      wrap: true,
      width: "300px",
      cell: (row) => (
        <>
          <div
            style={
              row.status == 1
                ? {
                  height: "20px",
                  width: "20px",
                  border: "2px Solid #000",
                  backgroundColor: "Green",
                  borderRadius: "50%"
                }
                : {
                  height: "20px",
                  width: "20px",
                  border: "2px Solid #000",
                  backgroundColor: "Red",
                  borderRadius: "50%"
                }
            }
          ></div>
          <a
            href="#"
            onClick={() => {
              getmember(row.m_id);
            }}
          >
            <Tooltip title="Edit Member">
              <IconButton>
                <EditSharp color="warning" />
              </IconButton>
            </Tooltip>
          </a>
          <a
            onClick={() => {
              handleGetMemberConnectedandBlockList(row.m_id);
              // setSeeMemberDeActiveModal(true);
              // setDeActivateReasonData({
              //   ...deActivateReasonData,
              //   memberName: row.m_name + "(" + row.business_name + ")",
              //   deActivationDate: row.deactivation_date,
              //   deActivationReason:
              //     row.member_deactive_reason != null ? row.member_deactive_reason : row.reason
              // });
            }}
          >
            <Tooltip title="View Connected and Block List">
              <IconButton>
                <ListAlt color="secondary" />
              </IconButton>
            </Tooltip>
          </a>
          {row.status == 0 && (
            <a
              onClick={() => {
                setSeeMemberDeActiveModal(true);
                setDeActivateReasonData({
                  ...deActivateReasonData,
                  memberName: row.m_name + "(" + row.business_name + ")",
                  deActivationDate: row.deactivation_date,
                  deActivationReason:
                    row.member_deactive_reason != null ? row.member_deactive_reason : row.reason
                });
              }}
            >
              <Tooltip title="See Deactivate Reason">
                <IconButton>
                  <RemoveRedEye color="success" />
                </IconButton>
              </Tooltip>
            </a>
          )}

          {/* <FormControl component="fieldset"> */}
          {/* <FormLabel component="legend" sx={{ fontSize: "0.75rem" }}>
              Enable Orange Tick
            </FormLabel> */}
          <FormGroup>
            <FormControlLabel
              control={
                <OrangeSwitch
                  onChange={async (event, checked) => {
                    const response = await GetPrimeMemberById(row.m_id);
                    setOrangeTickStatus(checked ? 3 : 0);

                    setEditMemberData({
                      ...response.data,
                      c_id: response?.data.country_id,
                      occupation_type: response?.data?.pr_occupation_type
                    });

                    // getmember(row.m_id);
                    setOrangeTickConfirmationModalOpen(true);
                  }}
                  checked={row.m_verify_status === 3}
                />
              }
            />
          </FormGroup>
          {/* </FormControl> */}

          {row.pr_i_generate == 0 ? (
            <a
              onClick={() => {
                setGenerateInvocieModal(true);
                setInvocieData({
                  pr_gst_check: "",
                  pr_gstno: "",
                  m_id: row.m_id
                });
              }}
            >
              <Tooltip title="Generate Invoice">
                <IconButton>
                  <Description color="secondary" />
                </IconButton>
              </Tooltip>
            </a>
          ) : (
            <Tooltip title="Download Invoice">
              <IconButton
                onClick={() => {
                  downloadInvocieData(row.m_id);
                }}
                disabled={downloadingId === row.m_id}
              >
                {downloadingId === row.m_id ? (
                  <CircularProgress size={24} color="secondary" />
                ) : (
                  <DownloadOutlined color="secondary" />
                )}
              </IconButton>
            </Tooltip>
          )}

          {row.is_login == 1 ? (
            <a
              onClick={() => {
                ulogout(row.m_id);
              }}
            >
              <Tooltip title="Logout Member">
                <IconButton>
                  <LogoutSharp color="error" />
                </IconButton>
              </Tooltip>
            </a>
          ) : (
            ""
          )}
        </>
      )
    }
  ];

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 800,
    bgcolor: "background.paper",
    boxShadow: 10,
    borderRadius: "10px",
    p: 2
  };
  const invoicestyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 500,
    bgcolor: "background.paper",
    boxShadow: 10,
    borderRadius: "10px",
    p: 2
  };

  const cancelmemberDeActiveModal = () => {
    setmemberDeActiveModal(false);
    setMemberdeactiveReasons({
      m_id: "",
      status: "",
      reasons: "",
      deactivation_date: null
    });
  };

  const closeMemberDeActiveModal = () => {
    setSeeMemberDeActiveModal(false);
    setDeActivateReasonData({
      memberName: "",
      deActivationDate: "",
      deActivationReason: ""
    });
  };

  const cancelMemberInvoiceModal = () => {
    setGenerateInvocieModal(false);
    setInvocieData({
      pr_gst_check: "",
      pr_gstno: "",
      m_id: ""
    });
  };

  const memberStatus = [
    { label: "All", value: 0 },
    { label: "Active Member", value: 1 },
    { label: "De-Active Member", value: 2 }
  ];

  const memberType = [
    { label: "All", value: -1 },
    { label: "Prime Member", value: 0 },
    { label: "Privilege Member", value: 1 },
    { label: "Prime Offline", value: 2 }
  ];

  const invocieStatus = [
    { label: "All", value: -1 },
    { label: "Invoice Not Generated", value: 0 },
    { label: "Invoice Generated", value: 1 }
  ];

  const memberTick = [
    { label: "All", value: -1 },
    { label: "Not Approved", value: 0 },
    { label: "Orange Tick", value: 3 }
  ];

  const whatsappGroupOptions = [
    { label: "All", value: -1 },
    { label: "Added", value: 1 },
    { label: "Not Added", value: 2 }
  ];

  const [memberDeactivateReason, setMemberDeactivateReason] = useState([]);

  const getMemberDeactivateReasons = async () => {
    let res = await getPrimeMemberDeactiveReason();
    setMemberDeactivateReason(res);
  };

  useEffect(async () => {
    getallcitylist();
    getallstatelist();
    getMemberDeactivateReasons();
    handleGetPromoCodeData();
  }, []);

  return (
    <>
      {/* Member Deactivate Add Reason Modal */}
      <Modal
        open={memberDeActiveModal}
        onClose={cancelmemberDeActiveModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            Add Member De-activation Reason
          </Typography>

          <div style={{ padding: "10px" }}>
            <div style={{ maxHeight: "480px" }}>
              <Stack spacing={10} style={{ marginBottom: "10px", marginTop: "10px" }}>
                <Stack spacing={10} style={{ marginBottom: "15px" }}>
                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <Stack spacing={3} style={{ marginBottom: "15px" }}>
                        <LocalizationProvider
                          dateAdapter={AdapterDateFns}
                          adapterLocale={enGB}
                          style={{ marginTop: "15px" }}
                        >
                          <DatePicker
                            type="date"
                            name="deactivation_date"
                            label="Date "
                            inputFormat="dd/MM/yyyy"
                            value={
                              memberdeactiveReasons.deactivation_date != null
                                ? new Date(
                                  memberdeactiveReasons.deactivation_date
                                    .split("-")
                                    .reverse()
                                    .join("-")
                                ) // Converts "DD-MM-YYYY" to "YYYY-MM-DD"
                                : null
                            }
                            onChange={(newDate) => {
                              if (newDate instanceof Date && !isNaN(newDate)) {
                                const day = String(newDate.getDate()).padStart(2, "0");
                                const month = String(newDate.getMonth() + 1).padStart(2, "0");
                                const year = newDate.getFullYear();
                                setMemberdeactiveReasons({
                                  ...memberdeactiveReasons,
                                  deactivation_date: `${day}-${month}-${year}`
                                });
                              }
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                required
                                onKeyDown={(e) => e.preventDefault()}
                              />
                            )}
                          />
                        </LocalizationProvider>
                      </Stack>
                    </Grid>
                    <Grid item xs={12}>
                      <Stack spacing={10} style={{ marginBottom: "15px" }}>
                        <label style={{ marginBottom: "10px" }}>Member Deactivate Reason</label>
                        <Select
                          // value={}
                          style={{ marginTop: "0px" }}
                          name="city_id"
                          onChange={(e) => {
                            setMemberdeactiveReasons({
                              ...memberdeactiveReasons,
                              reason: e.value
                            });
                          }}
                          options={
                            memberDeactivateReason?.map((c) => ({
                              value: c.m_d_r_id,
                              label: c.member_deactive_reason
                            })) || []
                          }
                        ></Select>
                      </Stack>
                    </Grid>
                  </Grid>
                </Stack>
              </Stack>
            </div>
            <hr />
            <div
              style={{
                margin: "10px auto",
                display: "flex",
                justifyContent: "space-between"
              }}
            >
              <Button
                variant="outlined"
                onClick={() => {
                  setmemberDeActiveModal(false);
                }}
              >
                Close
              </Button>
              <Button
                variant="contained"
                disabled={statusChangeLoading}
                onClick={() => {
                  changestatus(
                    memberdeactiveReasons.m_id,
                    memberdeactiveReasons.status,
                    memberdeactiveReasons.reason,
                    memberdeactiveReasons.deactivation_date
                  );
                }}
                startIcon={statusChangeLoading && <CircularProgress size={20} color="inherit" />}
              >
                Confirm
              </Button>
            </div>
          </div>
        </Box>
        {/* changestatus(row.m_id, 0); */}
      </Modal>
      {/* Start Display Member Deactivation Reason Modal */}
      <Modal
        open={seeMemberDeActiveModal}
        onClose={closeMemberDeActiveModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography
            align="center"
            id="modal-modal-title"
            variant="h6"
            component="h2"
            style={{ borderBottom: "1px solid", paddingBottom: "5px" }}
          >
            Member Detactivation Reason
          </Typography>

          <div style={{ padding: "10px" }}>
            <div style={{ maxHeight: "480px" }}>
              <Stack spacing={10} style={{ marginBottom: "10px", marginTop: "10px" }}>
                <Grid container spacing={2}>
                  <Grid item xs={3}>
                    <b>Member Name</b>
                  </Grid>
                  <Grid item xs={9}>
                    <span>: {deActivateReasonData.memberName}</span>
                  </Grid>

                  <Grid item xs={3}>
                    <b>Deactivation Date</b>
                  </Grid>
                  <Grid item xs={9}>
                    <span>
                      :
                      {deActivateReasonData.deActivationDate != null ? (
                        deActivateReasonData.deActivationDate
                      ) : (
                        <span style={{ marginLeft: "80px" }}>-</span>
                      )}
                    </span>
                  </Grid>

                  <Grid item xs={3}>
                    <b>Reason</b>
                  </Grid>
                  <Grid item xs={9}>
                    <span>
                      :
                      {deActivateReasonData.deActivationReason != null ? (
                        deActivateReasonData.deActivationReason
                      ) : (
                        <span style={{ marginLeft: "80px" }}>-</span>
                      )}
                    </span>
                  </Grid>
                </Grid>
              </Stack>
            </div>
          </div>
          <div
            style={{
              margin: "10px auto",
              display: "flex",
              justifyContent: "center"
            }}
          >
            <Button variant="contained" onClick={closeMemberDeActiveModal}>
              Close
            </Button>
          </div>
        </Box>
      </Modal>
      {/* End Display Member Deactivation Reason Modal */}
      <Modal
        open={generateInvocieModal}
        onClose={cancelMemberInvoiceModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={{ ...invoicestyle }}>
          <Typography
            align="center"
            id="modal-modal-title"
            variant="h4"
            style={{ borderBottom: "2px solid #000", paddingBottom: "10px" }}
          >
            Generate Invoice
          </Typography>
          <Stack mt={3} mb={3}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <FormLabel id="demo-row-radio-buttons-group-label" style={{ marginBottom: "0px" }}>
                  GST Type
                </FormLabel>
                <RadioGroup
                  style={{ marginTop: "0px", display: "flex", flexFlow: "row" }}
                  row
                  value={invoiceData.pr_gst_check}
                  onChange={handlememberinvoiceform}
                  aria-labelledby="demo-row-radio-buttons-group-label"
                  name="pr_gst_check"
                >
                  <FormControlLabel value="1" control={<Radio />} label="GST" />
                  <FormControlLabel value="0" control={<Radio />} label="Non GST" />
                </RadioGroup>
              </Grid>
              {invoiceData.pr_gst_check == 1 && (
                <Grid item xs={12}>
                  <Stack spacing={3} style={{ marginBottom: "15px" }}>
                    <TextField
                      style={{ marginTop: "0px" }}
                      fullWidth
                      autoComplete="off"
                      type="text"
                      label="Enter GST No."
                      name="pr_gstno"
                      value={invoiceData?.pr_gstno}
                      onChange={handlememberinvoiceform}
                    />
                  </Stack>
                </Grid>
              )}
            </Grid>
          </Stack>
          <hr />
          <Stack direction="row" spacing={2} justifyContent="center" mt={2}>
            <Button
              variant="outlined"
              onClick={() => {
                setIsLoading_invoiceMember(false);
                setGenerateInvocieModal(false);
                setInvocieData({
                  pr_gst_check: "",
                  pr_gstno: "",
                  m_id: ""
                });
              }}
            >
              Close
            </Button>
            <Button
              variant="contained"
              disabled={isLoading_invoiceMember}
              onClick={submitMemberInvoiceForm}
            >
              Confirm
              {isLoading_invoiceMember && (
                <CircularProgress size={14} style={{ marginLeft: "5px" }} />
              )}
            </Button>
          </Stack>
        </Box>
      </Modal>

      {/* Page Contend */}
      <Page title="Member | Local Vocal Business Group">
        <Container>
          <Stack direction="row" alignItems="center" justifyContent="space-between" mb={1}>
            <Typography variant="h4" gutterBottom>
              Member
            </Typography>
            {(loginUser?.u_type == 3 || (loginUser?.u_type == 2 && loginUser?.p_user_id == 22)) && (
              <Button
                onClick={() => {
                  step == 1 ? setStep(2) : setStep(1);
                }}
                style={{ marginBottom: "15px" }}
                variant="contained"
              >
                {step == 1 ? "Add Member" : "Back"}
              </Button>
            )}
          </Stack>

          {step != 1 && (
            <Card
              style={{
                paddingTop: "25px",
                paddingBottom: "25px"
              }}
            >
              <MemberForm data={editMember} setStep={setStep} step={step} memberlist={memberlist} />
            </Card>
          )}
          {step == 1 && (
            <>
              <Card style={{ padding: "20px", paddingTop: "10px" }}>
                <Stack spacing={10}>
                  <Grid container columnSpacing={1}>
                    {/* Member Filter Features */}
                    {/* <Grid
                      item
                      xs={12}
                      style={{
                        marginTop: "0",
                        paddingTop: "0",
                        textAlign: "center"
                      }}
                    >
                      <h3>Member Filter</h3>
                    </Grid> */}
                    <Grid item xs={2}>
                      <Stack spacing={2}>
                        <label>Select State</label>
                        <Select
                          options={[
                            {
                              value: 0,
                              label: "All State"
                            },
                            ...statelist.map((state) => {
                              return {
                                label: state?.state_name,
                                value: state?.state_id
                              };
                            })
                          ]}
                          value={
                            filtereddata?.filterState == 0
                              ? {
                                value: 0,
                                label: "All State"
                              }
                              : statelist.map((state) => {
                                return (
                                  filtereddata?.filterState == state.state_id && {
                                    value: state.state_id,
                                    label: state.state_name
                                  }
                                );
                              })
                          }
                          onChange={(e) => {
                            setFilteredData({
                              ...filtereddata,
                              filterState: e.value
                            });
                          }}
                        />
                      </Stack>
                    </Grid>
                    <Grid item xs={2}>
                      <Stack spacing={2} style={{ marginBottom: "10px" }}>
                        <label>Select City</label>
                        <Select
                          options={[
                            {
                              value: 0,
                              label: "All City"
                            },
                            ...citylist
                              ?.filter((items) => items.state_id === filtereddata?.filterState)
                              .map((city) => {
                                return {
                                  label: city?.city_name,
                                  value: city?.city_id
                                };
                              })
                          ]}
                          value={
                            filtereddata?.filterCity == 0
                              ? {
                                value: 0,
                                label: "All City"
                              }
                              : citylist
                                ?.filter((items) => items.state_id === filtereddata?.filterState)
                                .map((city) => {
                                  return (
                                    filtereddata?.filterCity == city.city_id && {
                                      value: city.city_id,
                                      label: city.city_name
                                    }
                                  );
                                })
                          }
                          onChange={(e) => {
                            setFilteredData({
                              ...filtereddata,
                              filterCity: e.value
                            });
                          }}
                        />
                      </Stack>
                    </Grid>
                    <Grid item xs={3}>
                      <Stack spacing={3} style={{ marginBottom: "10px" }}>
                        <label>Select Member Status</label>
                        <Select
                          value={memberStatus.map((c) => {
                            if (c.value == filtereddata?.activeMemberSearchType) {
                              return { value: c.value, label: c.label };
                            }
                          })}
                          onChange={(e) => {
                            setFilteredData({
                              ...filtereddata,
                              activeMemberSearchType: e.value
                            });
                          }}
                          options={memberStatus}
                        />
                      </Stack>
                    </Grid>

                    <Grid item xs={2}>
                      <Stack spacing={2} style={{ marginBottom: "15px" }}>
                        <label>Select Member Type</label>
                        <Select
                          value={memberType.map((c) => {
                            if (c.value == filtereddata?.memberSource) {
                              return { value: c.value, label: c.label };
                            }
                          })}
                          onChange={(e) => {
                            setFilteredData({
                              ...filtereddata,
                              memberSource: e.value
                            });
                          }}
                          options={memberType}
                        />
                      </Stack>
                    </Grid>

                    <Grid item xs={3}>
                      <Stack spacing={2} style={{ marginBottom: "15px" }}>
                        <label>Select Promocode</label>
                        <Select
                          value={
                            filtereddata?.promocode == 0
                              ? {
                                value: 0,
                                label: "All Promocode"
                              }
                              : promocodeList
                                ?.filter((items) => items.p_code_id === filtereddata?.promocode)
                                .map((promo) => {
                                  return (
                                    filtereddata?.promocode == promo.p_code_id && {
                                      value: promo.p_code_id,
                                      label: promo.p_code
                                    }
                                  );
                                })
                          }
                          onChange={(e) => {
                            setFilteredData({
                              ...filtereddata,
                              promocode: e.value
                            });
                          }}
                          options={[
                            {
                              value: 0,
                              label: "All Promocode"
                            },
                            ...promocodeList?.map((promo) => {
                              return {
                                label: promo?.p_code,
                                value: promo?.p_code_id
                              };
                            })
                          ]}
                        />
                      </Stack>
                    </Grid>
                    <Grid item xs={3}>
                      <Stack spacing={3} style={{ marginBottom: "10px" }}>
                        <label>Select Whatsapp Group</label>
                        <Select
                          options={whatsappGroupOptions}
                          value={whatsappGroupOptions.map((c) => {
                            if (c.value == filtereddata?.whatsappgroup) {
                              return { value: c.value, label: c.label };
                            }
                          })}
                          onChange={(e) => {
                            setFilteredData({
                              ...filtereddata,
                              whatsappgroup: e.value
                            });
                          }}
                          hideSelectedOptions={false}
                          isClearable={false}
                        />
                      </Stack>
                    </Grid>

                    <Grid item xs={3} style={{ paddingTop: "0px !important" }}>
                      <Stack spacing={3}>
                        <label>Select Invoice Status</label>
                        <Select
                          value={invocieStatus.map((c) => {
                            if (c.value == filtereddata?.activeMemberInvoice) {
                              return { value: c.value, label: c.label };
                            }
                          })}
                          onChange={(e) => {
                            setFilteredData({
                              ...filtereddata,
                              activeMemberInvoice: e.value
                            });
                          }}
                          options={invocieStatus}
                        />
                      </Stack>
                    </Grid>
                    <Grid item xs={3}>
                      <Stack spacing={3} style={{ marginBottom: "15px" }}>
                        <label>Select Gender</label>
                        <Select
                          value={[
                            { label: "All", value: -1 },
                            { label: "Not Selected", value: 0 },
                            ...gender
                          ].find((c) => c.value === filtereddata?.gender)}
                          onChange={(e) => {
                            setFilteredData({
                              ...filtereddata,
                              gender: e.value
                            });
                          }}
                          options={[
                            { label: "All", value: -1 },
                            { label: "Not Selected", value: 0 },
                            ...gender
                          ]}
                        />
                      </Stack>
                    </Grid>

                    <Grid item xs={3}>
                      <Stack spacing={3} style={{ marginBottom: "15px" }}>
                        <label>Select Member Tick</label>
                        <Select
                          isMulti
                          options={memberTick}
                          value={memberTick.filter((c) =>
                            filtereddata?.activeMemberTickType.includes(c.value)
                          )}
                          onChange={(selectedOptions) => {
                            const values = selectedOptions.map((opt) => opt.value);
                            // If All (-1) is selected along with others, remove All from the list
                            let finalValues =
                              values.includes(-1) && values.length > 1
                                ? values.filter((val) => val !== -1)
                                : values;

                            setFilteredData({
                              ...filtereddata,
                              activeMemberTickType: finalValues
                            });
                          }}
                          hideSelectedOptions={false}
                          isClearable={false}
                        />
                      </Stack>
                    </Grid>

                    <Grid item xs={3}>
                      <Stack spacing={3} style={{ marginBottom: "10px" }}>
                        <label>Search Member</label>
                        <TextField
                          style={{ marginTop: "0px" }}
                          autoComplete="off"
                          type="text"
                          size="small"
                          name="search"
                          value={filtereddata?.filtermember ? filtereddata?.filtermember : ""}
                          onChange={(e) => {
                            setFilteredData({
                              ...filtereddata,
                              filtermember: e.target.value
                            });
                          }}
                        />
                      </Stack>
                    </Grid>
                    {/* Member Search  */}

                    <Grid
                      item
                      xs={12}
                      style={{
                        marginTop: "0",
                        paddingTop: "0",
                        textAlign: "center"
                      }}
                    >
                      <h3>Member Search By Joining, Expire Or Deactivate Date</h3>
                    </Grid>

                    <Grid item xs={4}>
                      <FormLabel
                        id="demo-row-radio-buttons-group-label"
                        style={{ marginBottom: "0px" }}
                      >
                        Search Member by Date
                      </FormLabel>
                      <RadioGroup
                        style={{ marginTop: "0px" }}
                        row
                        value={filtereddata?.search_date_type}
                        onChange={(e) => {
                          setFilteredData({
                            ...filtereddata,
                            search_date_type: e.target.value
                          });
                        }}
                        aria-labelledby="demo-row-radio-buttons-group-label"
                        name="p_type"
                      >
                        <FormControlLabel
                          value="0"
                          control={<Radio />}
                          label="Search on Join Date"
                        />
                        <FormControlLabel
                          value="1"
                          control={<Radio />}
                          label="Search on Expire Date"
                        />
                        <FormControlLabel
                          value="2"
                          control={<Radio />}
                          label="Search on Deactivate Date"
                        />
                      </RadioGroup>
                    </Grid>

                    <Grid item xs={3}>
                      <Stack spacing={3} style={{ marginBottom: "15px" }}>
                        <LocalizationProvider
                          dateAdapter={AdapterDateFns}
                          adapterLocale={enGB}
                          style={{ marginTop: "15px" }}
                        >
                          <DatePicker
                            type="date"
                            name="s_date"
                            label="Start Date "
                            inputFormat="dd/MM/yyyy"
                            value={
                              filtereddata?.startDate != null
                                ? new Date(filtereddata?.startDate.split("-").reverse().join("-")) // Converts "DD-MM-YYYY" to "YYYY-MM-DD"
                                : null
                            }
                            onChange={(newDate) => {
                              if (newDate instanceof Date && !isNaN(newDate)) {
                                const day = String(newDate.getDate()).padStart(2, "0");
                                const month = String(newDate.getMonth() + 1).padStart(2, "0");
                                const year = newDate.getFullYear();
                                setFilteredData({
                                  ...filtereddata,
                                  startDate: `${day}-${month}-${year}`
                                });
                              }
                            }}
                            renderInput={(params) => (
                              <TextField {...params} onKeyDown={(e) => e.preventDefault()} />
                            )}
                          />
                        </LocalizationProvider>
                      </Stack>
                    </Grid>

                    <Grid item xs={3}>
                      <Stack spacing={3} style={{ marginBottom: "15px" }}>
                        <LocalizationProvider
                          dateAdapter={AdapterDateFns}
                          adapterLocale={enGB}
                          style={{ marginTop: "15px" }}
                        >
                          <DatePicker
                            type="date"
                            name="e_date"
                            label="End Date "
                            inputFormat="dd/MM/yyyy"
                            value={
                              filtereddata?.endDate != null
                                ? new Date(filtereddata?.endDate.split("-").reverse().join("-")) // Converts "DD-MM-YYYY" to "YYYY-MM-DD"
                                : null
                            }
                            onChange={(newDate) => {
                              if (newDate instanceof Date && !isNaN(newDate)) {
                                const day = String(newDate.getDate()).padStart(2, "0");
                                const month = String(newDate.getMonth() + 1).padStart(2, "0");
                                const year = newDate.getFullYear();
                                setFilteredData({
                                  ...filtereddata,
                                  endDate: `${day}-${month}-${year}`
                                });
                              }
                            }}
                            renderInput={(params) => (
                              <TextField {...params} onKeyDown={(e) => e.preventDefault()} />
                            )}
                          />
                        </LocalizationProvider>
                      </Stack>
                    </Grid>

                    <Grid
                      item
                      xs={2}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-around",
                        padding: "0"
                      }}
                    >
                      <Button variant="contained" onClick={FilterDateWise}>
                        Search
                      </Button>
                      <Button
                        variant="contained"
                        onClick={async () => {
                          setFilteredData({
                            filtermember: "",
                            startDate: null,
                            endDate: null,
                            search_date_type: 0,
                            activeMemberSearchType: 0,
                            memberSource: -1,
                            gender: -1,
                            activeMemberInvoice: -1,
                            activeInvoiceType: -1,
                            activeMemberTickType: [-1],
                            filterCity: 0,
                            filterState: 0,
                            whatsappgroup: -1,
                            promocode: 0
                          });
                        }}
                      >
                        Clear
                      </Button>
                    </Grid>

                    <Grid item xs={3}>
                      <Card>
                        <div
                          style={{
                            padding: "10px",
                            background: "#1c4766",
                            display: "flex",
                            justifyContent: "space-between",
                            color: "#fff"
                          }}
                        >
                          <h3>Active Member </h3>
                          <h3>{activeMembercnt}</h3>
                        </div>
                      </Card>
                    </Grid>
                    <Grid item xs={3}>
                      <Card>
                        <div
                          style={{
                            padding: "10px",
                            background: "#1c4766",
                            display: "flex",
                            justifyContent: "space-between",
                            color: "#fff"
                          }}
                        >
                          <h3>Deactive Member </h3>
                          <h3>{deactiveMembercnt}</h3>
                        </div>
                      </Card>
                    </Grid>
                    <Grid item xs={6}>
                      {memberlist && (
                        <>
                          <Button className="btn btn-export">
                            <CSVLink
                              data={formattedCSVData}
                              headers={expo_columns}
                              filename={"MemberList.csv"}
                              className="btn btn-primary test"
                              target="_blank"
                            >
                              Export CSV
                            </CSVLink>
                          </Button>

                          <Button className="btn btn-export" color="secondary" variant="contained">
                            <CSVLink
                              data={newMemeberList}
                              headers={expo_columns_Additional}
                              filename={"MemberList With Additional Details.csv"}
                              target="_blank"
                              style={{ color: "#fff", textDecoration: "none" }}
                            >
                              Export Additional Info
                            </CSVLink>
                          </Button>
                        </>
                      )}
                    </Grid>
                  </Grid>
                </Stack>
                <DataTable
                  title="Member List"
                  filter
                  pagination
                  // highlightOnHover
                  columns={columns}
                  conditionalRowStyles={conditionalRowStyles}
                  data={newMemeberList}
                  progressPending={isLoading}
                  progressComponent={<CustomLoader />}
                />
              </Card>
            </>
          )}
          {/* End Category Form */}
        </Container>
      </Page>

      {/* Member Connected and Block List Modal - Redesigned */}
      <Modal
        open={connectedBlockModalOpen}
        onClose={() => setConnectedBlockModalOpen(false)}
        aria-labelledby="modal-connected-block-title"
        aria-describedby="modal-connected-block-description"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 600,
            maxWidth: "95%",
            bgcolor: "background.paper",
            boxShadow: 24,
            borderRadius: "12px",
            overflow: "hidden"
          }}
        >
          {/* Header */}
          <Box
            sx={{
              p: 2,
              borderBottom: "1px solid",
              borderColor: "divider",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center"
            }}
          >
            <Typography variant="h6" sx={{ fontWeight: 700, color: "#00182a" }}>
              Connected & Blocked Members
            </Typography>
            <IconButton size="small" onClick={() => setConnectedBlockModalOpen(false)}>
              <Close />
            </IconButton>
          </Box>

          {/* Tab Navigation */}
          <Tabs
            value={connectedBlockTab}
            onChange={(e, v) => setConnectedBlockTab(v)}
            sx={{
              borderBottom: 1,
              borderColor: "divider",
              bgcolor: "#f2f4f6",
              "& .MuiTab-root": { textTransform: "none", fontWeight: 600, minHeight: 48 },
              "& .Mui-selected": { color: "#00182a !important" },
              "& .MuiTabs-indicator": { backgroundColor: "#00182a" }
            }}
          >
            <Tab
              icon={<People sx={{ fontSize: 20 }} />}
              iconPosition="start"
              label={`Connected Members (${getMemberConnectedListData?.length || 0})`}
            />
            <Tab
              icon={<Block sx={{ fontSize: 20 }} />}
              iconPosition="start"
              label={`Blocked Members (${getMemberBlockListData?.length || 0})`}
            />
          </Tabs>

          {/* Scrollable Content */}
          <Box sx={{ height: 400, overflow: "auto", p: 2, "&::-webkit-scrollbar": { width: "4px" }, "&::-webkit-scrollbar-thumb": { backgroundColor: "#c3c7cd", borderRadius: "10px" } }}>
            {/* Connected Tab */}
            {connectedBlockTab === 0 && (
              <>
                <Box
                  sx={{
                    bgcolor: "#ebf9f1",
                    p: 1.5,
                    borderRadius: 2,
                    mb: 2,
                    display: "flex",
                    alignItems: "center",
                    gap: 1
                  }}
                >
                  <CheckCircle sx={{ color: "#2e7d32", fontSize: 20 }} />
                  <Typography variant="body2" sx={{ color: "#1b5e20", fontWeight: 600 }}>
                    {getMemberConnectedListData?.length || 0} Active Member Connections Confirmed
                  </Typography>
                </Box>
                {getMemberConnectedListData && getMemberConnectedListData.length > 0 ? (
                  getMemberConnectedListData.map((item, idx) => (
                    <Box
                      key={`connected-${idx}`}
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 2,
                        p: 1.5,
                        border: "1px solid",
                        borderColor: "divider",
                        borderRadius: 2,
                        mb: 1,
                        "&:hover": { boxShadow: 1 }
                      }}
                    >
                      <Box sx={{ position: "relative", display: "inline-block" }}>
                        <Avatar
                          src={item?.photo ? `${Routes.API_HOSTNAME}images/member/${item.photo}` : undefined}
                          sx={{
                            bgcolor: "#cce5ff",
                            color: "#1d4a6a",
                            fontWeight: 700,
                            width: 40,
                            height: 40,
                            fontSize: 16
                          }}
                        >
                          {item?.m_name
                            ?.split(" ")
                            .map((n) => n[0])
                            .join("")
                            .slice(0, 2)
                            .toUpperCase() || "?"}
                        </Avatar>
                        {(item?.m_verify_status === 1 || item?.m_verify_status === 2 || item?.m_verify_status === 3) && (
                          <Box
                            component="img"
                            src={item?.m_verify_status === 1 ? "/static/icons/verified.png" : item?.m_verify_status === 2 ? "/static/icons/verified_blue.png" : "/static/icons/verified_orange.png"}
                            alt="Verified"
                            sx={{ width: 16, height: 16, position: "absolute", top: -1, right: -1 }}
                          />
                        )}
                      </Box>
                      <Typography variant="body1" sx={{ fontWeight: 600, color: "#00182a" }}>
                        {item?.m_name}
                        {item?.chpt_name ? ` (${item.chpt_name})` : ""}
                      </Typography>
                    </Box>
                  ))
                ) : (
                  <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: 300, color: "text.secondary" }}>
                    <Typography>No Connected Members</Typography>
                  </Box>
                )}
              </>
            )}

            {/* Blocked Tab */}
            {connectedBlockTab === 1 && (
              <>
                <Box
                  sx={{
                    bgcolor: "#fce4e4",
                    p: 1.5,
                    borderRadius: 2,
                    mb: 2,
                    display: "flex",
                    alignItems: "center",
                    gap: 1
                  }}
                >
                  <WarningAmber sx={{ color: "#c62828", fontSize: 20 }} />
                  <Typography variant="body2" sx={{ color: "#c62828", fontWeight: 600 }}>
                    {getMemberBlockListData?.length || 0} Member{getMemberBlockListData?.length !== 1 ? "s" : ""} currently restricted from activities
                  </Typography>
                </Box>
                {getMemberBlockListData && getMemberBlockListData.length > 0 ? (
                  getMemberBlockListData.map((item, idx) => (
                    <Box
                      key={`blocked-${idx}`}
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 2,
                        p: 1.5,
                        border: "1px solid",
                        borderColor: "error.main",
                        borderRadius: 2,
                        mb: 1,
                        "&:hover": { boxShadow: 1 }
                      }}
                    >
                      <Box sx={{ position: "relative", display: "inline-block" }}>
                        <Avatar
                          src={item?.photo ? `${Routes.API_HOSTNAME}images/member/${item.photo}` : undefined}
                          sx={{
                            bgcolor: "#ffdad6",
                            color: "#93000a",
                            fontWeight: 700,
                            width: 40,
                            height: 40,
                            fontSize: 16
                          }}
                        >
                          {item?.m_name
                            ?.split(" ")
                            .map((n) => n[0])
                            .join("")
                            .slice(0, 2)
                            .toUpperCase() || "?"}
                        </Avatar>
                      </Box>
                      <Typography variant="body1" sx={{ fontWeight: 600, color: "#00182a", flex: 1 }}>
                        {item?.m_name}
                        {item?.chpt_name ? ` (${item.chpt_name})` : ""}
                      </Typography>
                    </Box>
                  ))
                ) : (
                  <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: 300, color: "text.secondary" }}>
                    <Typography>No Blocked Members</Typography>
                  </Box>
                )}
              </>
            )}
          </Box>

          {/* Footer */}
          <Box
            sx={{
              p: 2,
              borderTop: "1px solid",
              borderColor: "divider",
              bgcolor: "#f2f4f6",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center"
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <Switch
                checked={conMailStatus === 0}
                onChange={handleToggleConnectionMail}
                size="small"
                sx={{
                  "& .MuiSwitch-switchBase.Mui-checked": {
                    color: "#0b2d45",
                  },
                  "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                    backgroundColor: "#0b2d45",
                  }
                }}
              />
              <Typography variant="body2" sx={{ color: "#43474d", fontWeight: 500 }}>
                Stop connection mail
              </Typography>
            </Box>
            <Button
              variant="contained"
              onClick={() => setConnectedBlockModalOpen(false)}
              sx={{
                bgcolor: "#0b2d45",
                color: "#fff",
                textTransform: "none",
                px: 3,
                fontWeight: 600,
                "&:hover": { bgcolor: "#00182a" }
              }}
            >
              Close
            </Button>
          </Box>
        </Box>
      </Modal>

      <Modal
        open={orangeTickConfirmationModalOpen}
        onClose={() => {
          setOrangeTickConfirmationModalOpen(false);
        }}
        aria-labelledby="modal-orange-tick-approval"
        aria-describedby="modal-orange-tick-description"
      >
        <Box sx={style}>
          <Typography
            id="modal-orange-tick-approval"
            variant="h6"
            component="h2"
            align="center"
            style={{ borderBottom: "1px solid", paddingBottom: "5px" }}
          >
            Member Name: {editMember?.m_name}
          </Typography>
          <p style={{ textAlign: "center" }}>
            Are You Sure You Want To {editMember?.m_verify_status === 0 ? "Enable" : "Disable"}{" "}
            Orange Tick ?
          </p>
          <div style={{ margin: "10px auto", display: "flex", justifyContent: "center" }}>
            <Button
              style={{ margin: "auto 5px" }}
              variant="outlined"
              onClick={() => setOrangeTickConfirmationModalOpen(false)}
            >
              NO
            </Button>
            <Button
              style={{ margin: "auto 5px" }}
              variant="contained"
              onClick={() => {
                handleOrangeTickApproveReject();
              }}
              disabled={isLoading}
              startIcon={isLoading && <CircularProgress size={20} color="inherit" />}
            >
              Yes
            </Button>
          </div>
        </Box>
      </Modal>
    </>
  );
}
